import AdvancedController from "./advanced-controller"
import { gsap } from 'gsap'

export default class KeyvisualController extends AdvancedController {

  static targets = [
    // 'content'
    'fullscreenVideo'
  ];

  static values = {
    // isOpen: Boolean
    fullscreenVideo: String
  }

  connect() {
    super.connect();
  }

  onFullscreen(e) {
    e.preventDefault();
    // set the video source
    this.fullscreenVideoTarget.setAttribute('src', this.fullscreenVideoValue);
    // request fullscreen
    const elem = this.fullscreenVideoTarget
    var fullscreen = elem.webkitRequestFullscreen || elem.mozRequestFullScreen || elem.msRequestFullscreen;
    fullscreen.call(this.fullscreenVideoTarget);
    // play the video
    this.fullscreenVideoTarget.play();
  }

}
